// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getSpaClaim} from '../../shared/repositories';
import {readSpaTypes} from './spa-types';

export const readSpaClaim = claimNumber =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const spaClaims = await getSpaClaim(claimNumber);

            dispatch({
                data: spaClaims,
                type: actions.UPDATE_TCSM_SPA_CLAIM_DETAILS
            });

            dispatch(readSpaTypes(spaClaims.responsibleAccount.account));

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/action-creators/get-spa-claim.js